<mat-card *ngLet="{
                currentFolder: folderTreeState.highlighted$ | async,
                folderId: currentHighlight$ | async
            } as state">
    <div class="folders-management-container">
        <div class="tree-container">
            <div class="section-header">
                <div class="title">
                    <h2>
                        {{'folders_page_manage_folders' | translate}}
                    </h2>
                </div>
                <div class="actions">
                    <button [uiAuthorizeDisable]="'Units.Create'"
                            [matTooltip]="'upsert_folder_new_first_level' | translate"
                            (click)="openCreateFolderModal()"
                            mat-mini-fab
                            color="primary"
                            data-cy="add-first-level-folder"
                            type="button">
                        <mat-icon>create_new_folder</mat-icon>
                    </button>
                    <button *uiModernContext
                            [uiAuthorizeDisable]="folderPermission('Create')"
                            [folderId]="state.folderId"
                            [disableIf]="state.currentFolder?.type !== FolderType.Modern ||
                                         state.currentFolder?.level === MaxFolderDepth"
                            [matTooltip]="'folders_page_add_subfolder' | translate"
                            (click)="openCreateFolderModal(state.currentFolder)"
                            mat-mini-fab
                            color="primary"
                            data-cy="add-subfolder">
                        <mat-icon>account_tree</mat-icon>
                    </button>
                </div>
            </div>

            <ui-folder-tree [context]="'manage'"
                            [state]="folderTreeState">
            </ui-folder-tree>
        </div>
        <div class="current-folder-container">
            <ng-container *ngIf="state.currentFolder">
                <div class="section-header">
                    <div class="title">
                        <ui-folder-tree-breadcrumbs [folder]="state.currentFolder"
                                                    [showFolderIcon]="true">
                        </ui-folder-tree-breadcrumbs>

                        <div *ngIf="!!state.currentFolder?.description"
                             class="folder-description">
                            <div class="description-label">
                                {{'folders_page_description' | translate}}
                            </div>
                            <div class="description-text"
                                 data-cy="folder-description">
                                {{ state.currentFolder?.description }}
                            </div>
                        </div>
                    </div>
                    <div class="actions">
                        <button [matTooltip]="'current_folder_type_tooltip_' + state.currentFolder!.type | translate"
                                mat-icon-button
                                type="button">
                            <mat-icon svgIcon="uipath:info"></mat-icon>
                        </button>

                        <button [uiAuthorizeDisable]="folderPermission('Edit', 'Delete')"
                                [folderId]="state.folderId"
                                [matMenuTriggerFor]="folderMenu"
                                mat-mini-fab
                                color="primary"
                                data-cy="current-folder-menu"
                                type="button">
                            <mat-icon svgIcon="uipath:More"></mat-icon>
                        </button>
                        <mat-menu #folderMenu="matMenu">
                            <button [uiAuthorizeDisable]="folderPermission('Edit')"
                                    [folderId]="state.folderId"
                                    (click)="openEditFolderModal(state.currentFolder)"
                                    mat-menu-item
                                    data-cy="edit-current-folder"
                                    type="button">
                                <mat-icon svgIcon="uipath:Edit"></mat-icon>
                                {{'folders_page_edit' | translate}}
                            </button>
                            <button [uiAuthorizeDisable]="folderPermission('Delete')"
                                    [folderId]="state.folderId"
                                    (click)="removeFolder(state.currentFolder)"
                                    mat-menu-item
                                    color="warn"
                                    data-cy="remove-current-folder"
                                    type="button">
                                <mat-icon svgIcon="uipath:Delete"></mat-icon>
                                {{'folders_page_remove' | translate}}
                            </button>
                        </mat-menu>
                    </div>
                </div>

                <ui-folder-users-grid *ngIf="canViewUsersGrid$ | async; else insufficientPermissionsForGrid"
                                      [folder]="state.currentFolder">
                </ui-folder-users-grid>

                <ng-template #insufficientPermissionsForGrid>
                    {{ 'folders_page_assign_permissions' | translate }}
                </ng-template>
            </ng-container>
        </div>
    </div>
</mat-card>
